export const document = {
    namespaced: true,
    state: {
        type: '',
        path: ''
    },
    actions: {
        show({ commit }, data) {
            commit('show', data);
        },
        clear({ commit }) {
            commit('clear');
        }
    },
    mutations: {
        show(state, data) {
            state.type = data.type;
            state.path = data.path;
        },
        clear(state) {
            state.type = '';
            state.path = '';
        }
    }
}
